
export function HowItWorks() {
  const handleAssessment = () => {
    window.REACT_APP_NAVIGATE('/property-assessment');
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: '1',
      title: 'Tell us about your property',
      description: 'Share basic details about your home, location, ownership structure, and rental goals. This helps us understand your unique situation.'
    },
    {
      number: '2',
      title: 'We review rules and eligibility',
      description: 'Our team researches your city bylaws, zoning regulations, strata restrictions, and provincial requirements to determine what\'s legally permitted.'
    },
    {
      number: '3',
      title: 'We recommend the safest option',
      description: 'You receive a clear assessment with recommended rental strategies that maximize income while staying fully compliant with all regulations.'
    },
    {
      number: '4',
      title: 'We manage or support your setup',
      description: 'Whether you want full management or just setup assistance, we guide you through licensing, listing creation, and operational launch.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-20">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A]">
            Simple and transparent
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#882629] transform -translate-x-1/2 hidden lg:block"></div>

          <div className="space-y-20">
            {steps.map((step, index) => (
              <div 
                key={index}
                className={`relative flex flex-col lg:flex-row items-center gap-8 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
              >
                <div className={`lg:w-1/2 ${index % 2 === 0 ? 'lg:text-right lg:pr-16' : 'lg:text-left lg:pl-16'}`}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h3 className="text-2xl font-semibold text-[#505A5A] mb-3">
                      {step.title}
                    </h3>
                    <p className="text-base text-[#505A5A]/70 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                <div className="relative z-10 flex-shrink-0">
                  <div className="w-16 h-16 bg-[#882629] rounded-full flex items-center justify-center shadow-xl">
                    <span className="text-white text-2xl font-bold">
                      {step.number}
                    </span>
                  </div>
                </div>

                <div className="lg:w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-20">
          <button 
            onClick={handleAssessment}
            className="bg-[#882629] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Start with step one
          </button>
        </div>
      </div>
    </section>
  );
}
